export default __webpack_public_path__ + "static/media/luty.9c48d808.mp3";